export const formatCurrency = (
  amount: number,
  currency: string = "USD",
): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

export const formatDate = (dateString: string | undefined | null) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  const lang = localStorage.getItem("i18nextLng") || "en";

  const use24Hour = lang !== "en";

  const localeMap: Record<string, string> = {
    uk: "uk-UA",
    ru: "ru-RU",
    en: "en-US",
  };

  const locale = localeMap[lang] || "en-US";

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: !use24Hour,
    second: "2-digit",
    fractionalSecondDigits: 3,
  }).format(date);
};

/** "08.10.26 22:55": day, month, two-digit year and 24-hour time, the same in every language. */
export const formatShortDateTime = (dateString: string | undefined | null) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return (
    `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${pad(date.getFullYear() % 100)} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

export const formatPercentage = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
};

export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat("en-US").format(value);
};
